// extracted by mini-css-extract-plugin
module.exports = {"Support":"Support_Support__9ayux"};